import React, { useState } from "react";
import { UnitSystem, useUnitSystem } from "../utils/Settings";
import { GetHeightValues } from "../utils/BMIUtils";
import { isValid } from '../utils/CVRiskUtils';
import NumericInput from "./NumericInput";

interface HeightInputProps {
    height: number,
    setHeight: (value:number) => void
};

const HeightInput : React.FC<HeightInputProps> = (props) => {
    const [unitSystem] = useUnitSystem();
    const [errorImperial, setErrorImperial] = useState<boolean>(false);

    let heightFt = Math.floor(props.height / 12);;
    let heightIn = props.height % 12;;

    const heightValues = GetHeightValues(unitSystem);
    let isValidHeight = isValid(props.height, heightValues[0], heightValues[1]);
    if (isValidHeight) {
        isValidHeight = unitSystem === UnitSystem.Metric || !errorImperial;
    }

    const setHeightImperial = (feet: number, inches: number) => {
        let errorImperial = inches < 0 || inches > 12 || feet < 0;
        setErrorImperial(errorImperial);

        if (!errorImperial) {
            let value = feet * 12 + inches;
            props.setHeight(value);
        }
    };

    if (unitSystem === UnitSystem.Metric) {
        return(
            <NumericInput value={props.height} min={heightValues[0]} max={heightValues[1]} onValueChange={(value:number) => props.setHeight(value)}/>
        );
    } else {
        return (
        <span>
            <NumericInput value={heightFt} min={Math.floor(heightValues[0]/12)} max={Math.floor(heightValues[1]/12)} onValueChange={(value:number) => setHeightImperial(Number(value), heightIn)}/>
            <NumericInput value={heightIn} min={0} max={12} onValueChange={(value:number) => setHeightImperial(heightFt, Number(value))}/>
        </span>
        );
    }
};

export default HeightInput;